import axios from "axios"
import config from "../config.js"
axios.defaults.baseURL=config.baseUrl
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
axios.defaults.headers.common['Referrer-Policy'] = 'strict-origin-when-cross-origin'